import { CircularProgress } from "@mui/material";
import { formatCurrency } from "@heartinz/finance";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { useRef, useState } from "react";
import Messages from "../../../../constants/Messages";
import handleError from "../../../../constants/handleError";
import AxiosInstance from "../../../AxiosInstance";
import { useNetwork } from "../../../../context/NetworkContext";
import { useShowAlert } from "../../../../context/AlertContext";
const PaySettleModal = ({
  isOpen,
  data,
  isBtnLoading,
  setIsPaySettleModalOpen,
  setIsMainModalOpen,
  setBtnLoading,
}) => {
  const buttonRef = useRef(null);
  const paymentmodeRef = useRef(null);
  const amountRef = useRef(null);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const [error, setErrors] = useState({});
  const [isPaysettleData, setPaysettleData] = useState({
    amount: "",
    paymentmode: "",
  });
  if (!isOpen) return null;
  const validateForm = () => {
    const errors = {};

    if (!isPaysettleData.amount) {
      errors.amount = Messages.ERROR.AMOUNT_EMPTY;
    } else if (!/^\d+(\.\d{0,2})?$/.test(isPaysettleData.amount)) {
      errors.amount = Messages.ERROR.INVALID_INPUT;
    } else if (!isPaysettleData.paymentmode) {
      errors.paymentmode = Messages.ERROR.PAYMODE_EMPTY;
    }

    setErrors(errors);

    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];
      switch (firstErrorField) {
        case "amount":
          amountRef.current?.focus();
          break;
        case "paymentmode":
          paymentmodeRef.current?.focus();
          break;
        default:
          break;
      }
    }

    return Object.keys(errors).length === 0;
  };
  const handlePaySettle = async () => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const payload = {
        amount: CurrencyConverter.toSubunit(isPaysettleData.amount, "INR"),
        paymentmode: isPaysettleData.paymentmode,
        saleid: data._id,
        customerid: data.saleto._id,
      };
      var response = await AxiosInstance.post(
        "add-paylater-settlement",
        payload,
      );
      data.paylateramount = response.data.results.paylateramount;
      showAlert("success", Messages.SUCCESS.PAYLATER_ADDED);
      handlePaySettleClose();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handlePaySettleClose = () => {
    setIsPaySettleModalOpen(false);
    setIsMainModalOpen(true);
    setPaysettleData({});
    setErrors({});
  };

  const onPaySettle = (event) => {
    event.preventDefault();
    if (!validateForm()) return;
    handlePaySettle();
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    let isValid = true;
    if (name === "amount") {
      if (value !== "" && !/^\d+(\.\d{0,2})?$/.test(value)) {
        isValid = false;
      }
    } else if (name === "paymentmode") {
      const allowedValues = ["CASH", "CARD", "ONLINE", "UPI"];
      if (value !== "" && !allowedValues.includes(value)) {
        isValid = false;
      }
    }

    if (isValid) {
      setPaysettleData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const handleEnterFocus = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      nextRef?.current?.focus();
    }
  };

  return (
    <>
      <div>
        <div className="modal-backdrop show"></div>
        <div
          className="modal show d-block"
          id="PaySettleModal"
          tabIndex="-1"
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title">Settle Amount</h6>
                <button
                  type="button"
                  onClick={handlePaySettleClose}
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form className="row g-3">
                  <div className="col-md-12">
                    <label className="form-label">
                      Amount <small className="text-danger">*</small>
                      <small className="ms-2 text-muted">
                        (Max:
                        {formatCurrency(
                          CurrencyConverter.toCurrency(
                            data?.paylateramount || 0,
                            "INR",
                          ),
                          "INR",
                          true,
                          true,
                        )}
                        {/* {formatCurrency(CurrencyConverter.toCurrency(
                            data.paylateramount,
                            "INR",
                          ))} */}
                        )
                      </small>
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className={`form-control`}
                      name="amount"
                      ref={amountRef}
                      onKeyDown={(e) => handleEnterFocus(e, paymentmodeRef)}
                      value={isPaysettleData.amount}
                      onChange={handleChange}
                      autoFocus
                    />
                    {error.amount && (
                      <div className="invalid-feedback">{error.amount}</div>
                    )}
                  </div>
                  <div className="col-md-12">
                    <label htmlFor="paymentmode" className="form-label">
                      Payment Mode <small className="text-danger">*</small>
                    </label>
                    <select
                      className={`form-select`}
                      name="paymentmode"
                      ref={paymentmodeRef}
                      onChange={handleChange}
                      onKeyDown={(e) => handleEnterFocus(e, buttonRef)}
                      value={isPaysettleData.paymentmode}
                    >
                      <option value="">Select</option>
                      <option value="CASH">Cash</option>
                      <option value="CARD">Card</option>
                      <option value="ONLINE">Online</option>
                      <option value="UPI">UPI</option>
                    </select>
                    {error.paymentmode && (
                      <div className="invalid-feedback">
                        {error.paymentmode}
                      </div>
                    )}
                  </div>
                </form>
              </div>
              <div className="modal-footer d-block">
                <button
                  onClick={handlePaySettleClose}
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-outline-secondary text-left"
                >
                  <i className="bx bx-x"></i> Close
                </button>

                {isBtnLoading ? (
                  <button className="btn btn-success pb-0 text-right" disabled>
                    <CircularProgress size={22} className="text-white" />
                  </button>
                ) : (
                  <button
                    ref={buttonRef}
                    type="button"
                    className="btn btn-success text-right"
                    onClick={onPaySettle}
                  >
                    <i className="bx bx-plus"></i> Settle
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaySettleModal;
